export default {_name:'list.simple',module:'Field',view:'Element/List/Simple',options:{xs:10,md:12,xl:12}}